import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  UnreadMessagesContainer,
  UnreadMessagesIconContainer
} from './UnreadMessages.styled';
import UnreadMessagesIcon from 'assets/icons/unread-messages.svg?react';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { pageUrl } from 'utilities/pageUrl';

import { UNREAD_MESSAGES_COUNT } from './UnreadMessages.graphql';

export const UnreadMessages = () => {
  const navigate = useNavigate();
  const { data, startPolling, stopPolling } = useQuery(UNREAD_MESSAGES_COUNT);

  useEffect(() => {
    startPolling(60000);

    return () => stopPolling();
  }, [startPolling, stopPolling]);

  if (!data?.unreadMessagesCount) {
    return null;
  }

  const count = data.unreadMessagesCount;

  return (
    <Container>
      <UnreadMessagesIconContainer>
        <UnreadMessagesIcon />
      </UnreadMessagesIconContainer>
      <UnreadMessagesContainer>
        <Heading tag="h2" noMargin>
          You have {count} unread message{count > 1 ? 's' : ''}!
        </Heading>
        <Button
          category="secondary"
          label="View Messages"
          onClick={() => navigate(pageUrl.messages())}
        />
      </UnreadMessagesContainer>
    </Container>
  );
};
